import React from 'react';
import { Flame, Award, Leaf, Droplet } from 'lucide-react';
import { Card } from './ui/card';

export const About = ({ product }) => {
  const icons = {
    0: Flame,
    1: Award,
    2: Leaf,
    3: Droplet
  };

  return (
    <section id="about" className="relative py-24 bg-black">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 10px, #dc2626 10px, #dc2626 11px)`
        }}></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-red-600"></div>
            <Flame className="w-8 h-8 text-red-600" />
            <div className="h-px w-12 bg-red-600"></div>
          </div>
          <h2 className="text-5xl sm:text-6xl font-black text-white mb-6 tracking-tight">
            SOBRE O RASPUTIN
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {product.description}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {product.features.map((feature, index) => {
            const IconComponent = icons[index];
            return (
              <Card
                key={index}
                className="bg-gradient-to-br from-zinc-900 to-black border-2 border-red-900/30 p-8 hover:border-red-600 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-red-600/20 group"
              >
                <div className="mb-6">
                  <div className="w-16 h-16 bg-red-950/50 rounded-lg flex items-center justify-center border-2 border-red-600 group-hover:bg-red-600 transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-red-500 group-hover:text-white transition-colors duration-300" />
                  </div>
                </div>
                <h3 className="text-xl font-black text-white mb-3 tracking-wide">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            );
          })}
        </div>

        {/* Heat Level Indicator */}
        <div className="max-w-4xl mx-auto">
          <Card className="bg-gradient-to-br from-zinc-900 to-black border-2 border-red-600 p-8 sm:p-12">
            <div className="text-center mb-8">
              <h3 className="text-3xl sm:text-4xl font-black text-white mb-3 tracking-wide">
                NÍVEL DE CALOR
              </h3>
              <p className="text-gray-400">Prepare-se para a experiência mais intensa</p>
            </div>
            
            <div className="relative">
              {/* Heat Bar */}
              <div className="h-12 bg-zinc-800 rounded-full overflow-hidden border-2 border-red-900/50">
                <div
                  className="h-full bg-gradient-to-r from-yellow-500 via-orange-600 to-red-600 relative overflow-hidden"
                  style={{ width: `${product.heatLevel * 10}%` }}
                >
                  {/* Animated shine effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
                </div>
              </div>
              
              {/* Scale Labels */}
              <div className="flex justify-between mt-4 text-sm font-bold">
                <span className="text-yellow-500">SUAVE</span>
                <span className="text-orange-500">MÉDIO</span>
                <span className="text-red-500">QUENTE</span>
                <span className="text-red-600">EXTREMO</span>
              </div>

              {/* Heat Level Number */}
              <div className="flex items-center justify-center gap-4 mt-8">
                <Flame className="w-12 h-12 text-red-600 animate-pulse" />
                <div className="text-center">
                  <div className="text-6xl font-black text-white">
                    {product.heatLevel}
                  </div>
                  <div className="text-sm text-gray-400 font-bold tracking-wider">DE 10</div>
                </div>
                <Flame className="w-12 h-12 text-red-600 animate-pulse" />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
